import React, { PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import PeriodFromTo from '../../coverNotePVComponent/periodFromTo/PeriodFromTo';
import CoverType from '../../coverNotePVComponent/coverType/CoverType';
import Value from '../../coverNotePVComponent/value/Value';

const CoverageInfo = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <h3 className="ebaoUtil__HeaderThree">Coverage Information</h3>
      <PeriodFromTo
        startDate={props.coverageInfo.coveragePeriodFrom}
        endDate={props.coverageInfo.coveragePeriodTo}
        startDateLabel="Period From *"
        endDateLabel="To *"
        handleChangeStartDate={props.handleChangeCoverageInfoPreviousFrom}
        handleChangeEndDate={props.handleChangeCoverageInfoPreviousTo}

      />
      <FormGroup controlId="">
        <Col sm={6}>
          <CoverType
            coverType={props.coverageInfo.coverType}
            handleChangeCoverType={props.handleChangeCoverageInfo}
          />
        </Col>
        <Col sm={6} />
      </FormGroup>
      <FormGroup controlId="">
        <Col sm={6}>
          <Value
            value={props.coverageInfo.value}
            handleChangeValue={props.handleChangeCoverageInfo}
            validDisabled={props.validDisabled}
          />
        </Col>
        <Col sm={6} />
      </FormGroup>
    </div>
  )
}

CoverageInfo.propTypes = {
  coverageInfo: PropTypes.object,
  handleChangeCoverageInfoPreviousTo: PropTypes.func,
  handleChangeCoverageInfoPreviousFrom: PropTypes.func,
  handleChangeCoverageInfo: PropTypes.func,
  validDisabled: PropTypes.bool
};

export default CoverageInfo;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/coverageInfo/CoverageInfo.js